export default () => ({
    handleAllSelected(tagId, currentValue) {
        if (!currentValue) {
            return this.selectedTags.map(Number).includes(tagId);
        }

        return currentValue;
    },

    hasSelectionsInOtherEvents(currentEventId) {
        return Object.keys(this.selectedItems)
            .filter((id) => id != currentEventId)
            .some((id) => {
                const eventSelection = this.selectedItems[id];

                if (eventSelection.manuallySelected?.length > 0) {
                    return true;
                }

                if (eventSelection.tags) {
                    return Object.values(eventSelection.tags).some((tag) => tag.allSelected);
                }

                return false;
            });
    },

    handleSelectionWithTags(currentSelected, hasOtherSelections) {
        const manuallySelectedLength = new Set(currentSelected.manuallySelected ?? []).size;
        const manuallyUnselectedLength = new Set(currentSelected.manuallyUnselected ?? []).size;

        const tagIds = this.selectedTags.map(Number);
        const allSelected = this.allCurrentSelectedTagsIsSelectAll(currentSelected, tagIds);

        if (allSelected && manuallySelectedLength === 0) {
            const emptyManuallyUnselectedForAllTags = this.selectedTags.every((id) => currentSelected.tags?.[id]?.manuallyUnselected?.length === 0);

            if (manuallyUnselectedLength === 0 && emptyManuallyUnselectedForAllTags) {
                return;
            }

            const hasUnselectedByTag = Object.values(currentSelected.tags).some(
                (tag) => tag.allSelected && tag.manuallyUnselected?.length > 0,
            );

            if (!hasUnselectedByTag) {
                return;
            }

            const unselectedIds = new Set();

            Object.entries(currentSelected.tags).forEach(([tagId, tag]) => {
                if (tagIds.includes(tagId) && tag.allSelected && tag.manuallyUnselected?.length > 0) {
                    tag.manuallyUnselected.forEach((id) => unselectedIds.add(id));
                }

                tag.manuallyUnselected = [];
            });

            return;
        };


        this.clearManuallySelectedIds(currentSelected);
    },

    handleDeselectionWithTags(currentSelected) {
        const manuallySelectedLength = new Set(currentSelected.manuallySelected ?? []).size;

        const selectedTagIds = this.selectedTags.map(Number);

        if (this.allCurrentSelectedTagsIsSelectAll(currentSelected, selectedTagIds)) {
            this.handleFullDeselection(currentSelected, selectedTagIds, manuallySelectedLength);
        } else if (
            !this.allCurrentSelectedTagsIsSelectAll(currentSelected, selectedTagIds) &&
            manuallySelectedLength === 0 &&
            currentSelected.manuallyUnselected?.length === 0
        ) {
            this.handleEmptyDeselectionWithPartialTags(currentSelected, selectedTagIds);
        } else if (
            !this.allCurrentSelectedTagsIsSelectAll(currentSelected, selectedTagIds) &&
            manuallySelectedLength > 0
        ) {
            this.handlePartialDeselection(currentSelected, selectedTagIds);
        } else if (currentSelected.manuallyUnselected?.length > 0) {
            currentSelected.manuallyUnselected = [];

            if (selectedTagIds.length === 1 && selectedTagIds[0] !== 0) {
                const notCurrentTagId = Object.values(this.availableTags).find(
                    (tag) => tag.id !== selectedTagIds[0] && tag.id !== 0,
                )?.id;

                const tagSelection = currentSelected.tags[notCurrentTagId];

                if (tagSelection.allSelected) {
                    tagSelection.manuallyUnselected = [
                        ...new Set([...(tagSelection.manuallyUnselected || []), ...this.duplicatedImageIds]),
                    ]
                }
            }
        }
    },

    handleFullDeselection(currentSelected, tagIds) {
        const duplicatedTiles = Object.values(this.tilesState).filter(
            (tile) => tile?.event_id == this.eventId && tile?.tags?.length > 1,
        );

        if (duplicatedTiles.length) {
            if (tagIds.length === 1) {
                this.insertDuplicatedTiles(currentSelected, duplicatedTiles, tagIds[0]);
            } else if (tagIds.length > 1) {
                const tagWithoutNoTag = tagIds.filter((tagId) => tagId != 0);
                this.insertDuplicatedTiles(currentSelected, duplicatedTiles, tagWithoutNoTag[0]);
            }
        }
    },

    handleEmptyDeselectionWithPartialTags(currentSelected, tagIds) {
        const duplicatedTiles = Object.values(this.tilesState).filter(
            (tile) => tile?.event_id == this.eventId && tile?.tags?.length > 1,
        );

        const shouldInsertDuplicatedTiles =
            duplicatedTiles.length && tagIds.length === 1 && !tagIds.map(Number).includes(0);

        if (shouldInsertDuplicatedTiles) {
            this.insertDuplicatedTiles(currentSelected, duplicatedTiles, tagIds[0]);
        }
    },

    handlePartialDeselection(currentSelected, tagIds) {
        const candidateToRemove = new Set(currentSelected.manuallySelected ?? []);

        const selectedManuallyFromCurrentTags = Object.values(this.tilesState)
            .filter((tile) => {
                if (!tile || tile.event_id !== this.eventId) {
                    return false;
                }

                const tileTags = Array.isArray(tile.tags) ? tile.tags : [];

                return (
                    candidateToRemove.has(tile.id) &&
                    (tileTags.some((tagId) => tagIds.includes(Number(tagId))) ||
                        (tileTags.length === 0 && tagIds.includes(0)))
                );
            })
            .map((tile) => tile.id);

        if (selectedManuallyFromCurrentTags.length === 0) {
            return;
        }

        candidateToRemove.forEach((id) => {
            if (selectedManuallyFromCurrentTags.includes(id)) {
                candidateToRemove.delete(id);
            }
        });

        currentSelected.manuallySelected = [...candidateToRemove];
    },

    insertDuplicatedTiles(currentSelected, duplicatedTiles, currentTagId) {
        const notCurrentTagId = Object.values(this.availableTags).find(
            (tag) => tag.id !== currentTagId && tag.id !== 0,
        )?.id;

        if (!currentSelected.tags[notCurrentTagId]) {
            currentSelected.tags[notCurrentTagId] = {
                allSelected: false,
                manuallyUnselected: [],
            };
        }

        if (!currentSelected.tags[currentTagId]) {
            currentSelected.tags[currentTagId] = {
                allSelected: false,
                manuallyUnselected: [],
            };
        }

        const notCurrentTag = currentSelected.tags[notCurrentTagId];
        const currentTag = currentSelected.tags[currentTagId];

        const newTileIds = duplicatedTiles.map((tile) => tile.id);

        const firstCondition =
            notCurrentTag.allSelected &&
            this.selectedTags.length === 1 &&
            this.selectedTags.map(Number)[0] !== 0;

        const secondCondition =
            notCurrentTag.allSelected &&
            !this.selectedTags.map(Number).includes(notCurrentTagId) &&
            currentTag.allSelected &&
            this.selectedTags.map(Number).includes(currentTagId);

        if (firstCondition || secondCondition) {
            currentSelected.manuallyUnselected = [
                ...new Set([...(currentSelected.manuallyUnselected || []), ...newTileIds]),
            ];

            notCurrentTag.manuallyUnselected = [
                ...new Set([...(notCurrentTag.manuallyUnselected || []), ...newTileIds]),
            ];
        }
    },

    clearManuallySelectedIds(currentSelected) {
        if (!currentSelected.manuallySelected || currentSelected.manuallySelected.length === 0) {
            return;
        }

        const selectedTagIds = this.selectedTags.map(Number);
        const eventId = this.eventId;

        const selectedTagIdsSet = new Set(selectedTagIds);
        const manuallySelectedSet = new Set(currentSelected.manuallySelected);

        const idsToRemove = Object.values(this.tilesState)
            .filter((tile) => {
                if (!tile || tile.event_id !== eventId) {
                    return false;
                }

                const tileTags = Array.isArray(tile.tags) ? tile.tags : [];

                return (
                    manuallySelectedSet.has(tile.id) &&
                    (tileTags.some((tagId) => selectedTagIdsSet.has(tagId)) ||
                        (tileTags.length === 0 && selectedTagIdsSet.has(0)))
                );
            })
            .map((tile) => tile.id);

        if (idsToRemove.length === 0) {
            return;
        }

        currentSelected.manuallySelected = currentSelected.manuallySelected.filter(
            (id) => !idsToRemove.includes(id),
        );
    },

    clearManuallyUnselectedFromTags(tagIds) {
        const currentSelected = this.selectedItems[this.eventId];

        if (!currentSelected || !currentSelected.tags) {
            return;
        }

        tagIds.forEach((tagId) => {
            const tagSelection = currentSelected.tags[tagId];

            if (tagSelection?.manuallyUnselected?.length > 0) {
                tagSelection.manuallyUnselected = tagSelection.manuallyUnselected.filter((id) => {
                    return !this.duplicatedImageIds.includes(id)
                });

                if (tagSelection.allSelected) {
                    tagSelection.manuallyUnselected = [];
                }
            }
        })
    },

    allCurrentSelectedTagsIsSelectAll(currentSelected, tagIds) {
        return (
            tagIds.length > 0 &&
            tagIds.every((id) => currentSelected.tags?.[`${id}`]?.allSelected ?? false)
        );
    },

    getTagsInitialState() {
        return {
            manuallySelected: [],
            manuallyUnselected: [],
            tags: Object.fromEntries(
                Object.values(this.availableTags).map((tag) => [tag.id, { allSelected: false, manuallyUnselected: [] }]),
            ),
        };
    },

    getRelevantTags() {
        return this.selectedTags.length
            ? Object.values(this.availableTags).filter((tag) =>
                  this.selectedTags.map(Number).includes(tag.id),
              )
            : Object.values(this.availableTags);
    },

    isTileSelected(tile, eventId) {
        const tileId = tile.id;
        const eventSelection = this.selectedItems[eventId];

        if (!eventSelection) return false;

        const hasTagWithAllSelected = tile.tags.some(
            (tagId) => eventSelection.tags[Number(tagId)]?.allSelected,
        );

        if (hasTagWithAllSelected) {
            return !eventSelection.manuallyUnselected.includes(tileId);
        }

        return eventSelection.manuallySelected.includes(tileId);
    },
});
